// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/documents/SegmentDocument/SegmentDocument.less
// module id = 1818
// module chunks = 0